export default {"src":"https://fishbrain.com/_next/static/media/southDakota.2475b54d.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};